import { useEffect, useRef } from "react";
import { posthog } from "@/lib/posthog";
import { useUser } from "@/lib/user-context";

export function PostHogIdentitySync() {
  const { session, isSessionLoading, systemRole } = useUser();
  const identifiedUserIdRef = useRef<string | null>(null);

  useEffect(() => {
    if (isSessionLoading) {
      return;
    }

    const userId = session?.user?.id ?? null;

    if (!userId) {
      if (identifiedUserIdRef.current) {
        posthog.reset();
        identifiedUserIdRef.current = null;
      }

      return;
    }

    posthog.identify(userId, {
      email: session?.user.email ?? undefined,
      name: session?.user.name ?? undefined,
      system_role: systemRole ?? undefined,
      surface: "app",
      app_host: window.location.hostname,
    });

    identifiedUserIdRef.current = userId;
  }, [isSessionLoading, session, systemRole]);

  return null;
}
